<template>
  <a :href="product.productUrl" class="link-wrapper">
    <div class="campaign-card" :class="{ wide: wide }">
      <div
        class="image"
        :style="'background-image: url(' + product.image + ')'"
      ></div>

      <div class="details">
        <!-- Title -->
        <h4>
          {{ product.projectTitle }}
          <span class="card-arrow"><i class="fas fa-chevron-right"></i></span>
        </h4>

        <!-- Countdown -->
        <p class="countdown">{{ daysLeft }}</p>

        <!-- Description and content -->
        <div class="description">
          <p>
            <span>{{ product.description }}</span>
          </p>

          <a :href="product.productUrl" class="lnk-arrw ra-cta">Learn more</a>
        </div>

        <!-- Barometer / Progress Bar -->
        <div class="goal-wrapper">
          <div class="progress-bar">
            <div class="progress-bar-wrapper">
              <div
                class="progress-bar-inner"
                :style="{ width: goalProgress + '%' }"
              ></div>
            </div>
          </div>

          <!-- Amount Raised -->
          <p>
            ${{ formatCurrency(product.currentDonationAmount) }} of ${{
              formatCurrency(product.goalAmount)
            }}<span class="hide-mobile"> raised</span>
          </p>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import moment from "moment";

export default {
  name: "Card",

  computed: {
    daysLeft: function () {
      const days = moment(this.product.dueDate).diff(moment(), "days");
      if (this.goalProgress === 100) return "Achieved!";
      if (days < 1 && this.goalProgress != 100) return "Completed";
      return `${days} Days Left`;
    },
    goalProgress: function () {
      const progress =
        (this.product.currentDonationAmount / this.product.goalAmount) * 100;
      return progress <= 100 ? progress : 100;
    },
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wide: {
      type: Boolean,
    },
  },

  methods: {
    formatCurrency(num) {
      const currencyStr = num.toFixed(2).toString().replace(".00", "");

      if (num >= 10000) {
        // Format with comma - 10,000, 1,000,000, etc.
        return currencyStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return currencyStr;
    },
  },
};
</script>

<style scoped>
.link-wrapper {
  display: block;
}

.campaign-card {
  --cardPadding: 1rem;

  display: grid;
  grid-template: 120px 1fr / 1fr;
  height: 100%;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 4px 114px rgba(0, 0, 0, 0.18);
}
.campaign-card h4 {
  font-size: 1.5rem;
}

.wide {
  grid-template: 240px 1fr / 1fr;
}
.wide h4 {
  font-size: 2rem;
}

.card-arrow {
  display: none;
}

.image {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: var(--wwfGreyDE);
}

.details {
  position: relative;
  padding: var(--cardPadding);
  background-color: var(--wwfWhite);
}

.description {
  padding-bottom: 5rem;
}

.description p {
  margin-bottom: 1rem;
}

.description span {
  display: none;
}

.description .lnk-arrw:after {
  content: "\f054";
  font-family: "FontAwesome";
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  margin-left: 7px;
  margin-right: 7px;
  -webkit-transform: scale(1.35);
  -ms-transform: scale(1.35);
  transform: scale(1.35);
  display: inline-block;
  vertical-align: -5%;
  color: var(--wwfOrange);
}

.description .lnk-arrw:hover:after {
  -webkit-animation: bscLnkAn 0.3s ease-in-out running forwards;
  animation: bscLnkAn 0.3s ease-in-out running forwards;
}

@-webkit-keyframes bscLnkAn {
  0% {
    margin-left: 7px;
    margin-right: 7px;
  }
  50% {
    margin-left: 10px;
    margin-right: 4px;
  }
  100% {
    margin-left: 7px;
    margin-right: 7px;
  }
}

@keyframes bscLnkAn {
  0% {
    margin-left: 7px;
    margin-right: 7px;
  }
  50% {
    margin-left: 10px;
    margin-right: 4px;
  }
  100% {
    margin-left: 7px;
    margin-right: 7px;
  }
}

.description .ra-cta {
  color: var(--wwfOrange);
  font-weight: 400;
  text-transform: none;
}

.description .ra-cta:hover {
  color: var(--wwfBlack);
}

.wide .description span {
  display: inline;
}

.goal-wrapper {
  position: absolute;
  left: 0;
  bottom: 2rem;
  width: 100%;
  padding: 0 var(--cardPadding);
}
.goal-wrapper p {
  font-size: 14px;
}

.countdown {
  margin-bottom: 0.5rem;
  font-family: "WWFRegular", sans-serif;
  font-size: 1rem;
  color: var(--wwfOrange);
}

.progress-bar-wrapper {
  width: 100%;
  height: 12px;
  margin: 1.5rem 0 1rem;
  background-color: var(--wwfGrey82);
  border-radius: 16px;
  overflow: hidden;
}

.progress-bar-inner {
  width: 100%;
  height: 100%;
  background-color: var(--wwfRegenerateSupportGreen);
  border-radius: 16px;
}

.hide-mobile {
  display: none;
}

@media only screen and (min-width: 768px) {
  .campaign-card {
    grid-template: 200px 1fr / 1fr;
  }
  .wide {
    grid-template: 450px / repeat(2, 1fr);
  }
  .countdown {
    font-size: 1.5rem;
  }
  .goal-wrapper p {
    font-size: 1rem;
  }
  .hide-mobile {
    display: inline;
  }
}

@media only screen and (min-width: 1200px) {
  .campaign-card {
    --cardPadding: 2rem;

    grid-template: 350px 1fr / 1fr;
  }
  .campaign-card h4 {
    font-size: 2rem;
  }
  .wide {
    grid-template: 500px / 2fr 1fr;
  }
  .details {
    padding: 2rem;
  }
  .card-arrow {
    display: inline;
    margin-top: 0.7rem;
    font-size: 1.2rem;
    float: right;
  }
  .countdown {
    margin-bottom: 1.5rem;
  }
  .description span {
    display: inline;
  }
}
</style>


// WEBPACK FOOTER //
// Card.vue?04cc0b32